
/**
 * N-291 (4A) · Un filtro «entre dos días» en UN campo, como en la maqueta («Pedido entre…»,
 * «Viaje entre…»). Se elige el primer día y el último en el mismo calendario; si se cierra con
 * un solo día elegido, es ese día. Avisa con `change` → `{ desde, hasta }` (`Y-m-d` o null).
 */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FormatHelper from '@/helpers/format-helper';

@Component
export default class DateRangeFilter extends Vue {
	@Prop({ default: '' }) private label!: string;
	@Prop({ default: null }) private desde!: string | null;
	@Prop({ default: null }) private hasta!: string | null;

	private abierto = false;
	private elegidos: string[] = [];

	get texto(): string {
		if (!this.desde) {
			return '';
		}
		const desde = FormatHelper.formatDate(this.desde);
		if (!this.hasta || this.hasta === this.desde) {
			return desde;
		}
		return desde + ' – ' + FormatHelper.formatDate(this.hasta);
	}

	@Watch('abierto')
	onAbierto(abierto: boolean) {
		if (abierto) {
			this.elegidos = this.desde ? [this.desde, this.hasta || this.desde] : [];
		} else if (this.elegidos.length === 1) {
			this.avisar(this.elegidos[0], this.elegidos[0]);
		}
	}

	elegir(dias: string[]) {
		this.elegidos = dias;
		if (dias.length === 2) {
			const [desde, hasta] = dias.slice().sort();
			this.avisar(desde, hasta);
			this.elegidos = [];
			this.abierto = false;
		}
	}

	borrar() {
		this.elegidos = [];
		this.avisar(null, null);
	}

	avisar(desde: string | null, hasta: string | null) {
		this.$emit('change', { desde, hasta });
	}
}
